export default __webpack_public_path__ + "static/media/Banner - Artisan - Brown.7994d2cd.jpg";